import { RedemptionService } from "../core/redemption-service";

export class LocalRedemptionService extends RedemptionService {
    getBaseUrl = () => `https://localhost:5001/api`;
}
